// @ts-nocheck
import {
  cartFetchAndRender,
  getShopifyRoot,
  setAddToCartButtonState,
  showCartErrorToast,
} from '@theme/lib-cart';
import {
  buildProductCartAddFormData,
  getCartAddLinesFromFormData,
  resolveVariantId,
} from '@theme/lib-product-form';

class BuyNow {
  /** @type {WeakSet<HTMLFormElement>} */
  #inFlightForms = new WeakSet();

  constructor() {
    document.addEventListener('click', (event) => this.#onClick(event));
  }

  /** @param {Event} event */
  #onClick(event) {
    if (event.defaultPrevented) return;

    const target = event.target;
    if (!(target instanceof Element)) return;

    const button = target.closest('[data-buy-now]');
    if (!(button instanceof HTMLButtonElement) || button.disabled) return;

    const form = button.form;
    if (!(form instanceof HTMLFormElement)) return;

    event.preventDefault();
    this.buyNow(form, button);
  }

  /**
   * @param {HTMLFormElement} form
   * @param {HTMLButtonElement} [clickedButton]
   */
  async buyNow(form, clickedButton) {
    if (this.#inFlightForms.has(form)) return;

    const button = clickedButton || form.querySelector('[data-buy-now]');
    if (!(button instanceof HTMLButtonElement)) return;

    const fallbackErrorMessage =
      button.getAttribute('data-message-error') ||
      Theme.translations.add_to_cart_error ||
      'Unable to buy this item right now.';

    const variantId = resolveVariantId(form, button);

    if (!variantId) {
      setAddToCartButtonState(button, 'error', {
        message: fallbackErrorMessage,
      });
      showCartErrorToast(fallbackErrorMessage);
      return;
    }

    this.#inFlightForms.add(form);
    setAddToCartButtonState(button, 'loading');

    const formData = buildProductCartAddFormData(form, {
      button,
      variantId,
    });
    const lines = getCartAddLinesFromFormData(formData);

    let redirecting = false;

    try {
      await cartFetchAndRender('cart/add.js', formData, {
        action: 'add',
        context: 'product',
        lines,
      });

      redirecting = true;
      window.location.assign(getShopifyRoot() + 'checkout');
    } catch (error) {
      if (error instanceof DOMException && error.name === 'AbortError') {
        setAddToCartButtonState(button, 'idle');
        return;
      }

      const message =
        error instanceof Error && error.message
          ? error.message
          : fallbackErrorMessage;

      setAddToCartButtonState(button, 'error', { message });
    } finally {
      if (!redirecting) {
        this.#inFlightForms.delete(form);
      }
    }
  }
}

new BuyNow();
